<template>
    <div>
        <Head :title="__('terms_of_services')" />
        <div class="bg-white rounded-md shadow overflow-hidden mr-2">
            <form @submit.prevent="update">
                <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
                    <text-input v-model="form.html.title" class="pr-6 pb-8 w-full lg:w-1/2" :label="__('Title')" />
                    <div class="pr-6 pb-8 w-full">
                        <label class="form-label">Page Content:</label>
                        <tiptap-editor v-model="form.html.content" />
                    </div>
                </div>
                <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex items-center">
                    <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">{{ __('Save') }}</loading-button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import { Link, Head } from '@inertiajs/vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import TiptapEditor from '@/Shared/TiptapEditor.vue'

export default {
    metaInfo: { title: 'Contact' },
    components: { Link, Head, TextInput, LoadingButton, TiptapEditor },
    layout: Layout,
    props: { page: Object },
    remember: 'form',
    data() {
        return {
            tabs: [
                {'name': 'Overview', 'active': true},
                {'name': 'List Information', 'active': false},
                {'name': 'Bottom', 'active': false},
            ],
            form: this.$inertia.form({
                title: 'Terms of Services',
                slug: 'terms',
                is_active: this.page.is_active,
                html: JSON.parse(this.page.html),
            }),
        }
    },
    methods: {
        update() { this.form.put(this.route('front_pages.update', 'terms')) },
        activeTab(index) {
            for (const tab_item of this.tabs) tab_item.active = false
            this.tabs[index].active = true
        },
    },
}
</script>
